module.exports = __webpack_public_path__ + "assets/img/index-partner23.527023a3.jpg";